import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
//compoents
import style from "./ewallet.module.scss";
import { useSelector } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataTable from "react-data-table-component";
import moment from "moment";
import Filter from "./Filter";
import { formatNumberWithCommasAndDecimal } from "../../../helper";
const stylees = {
  paddingTop: "10px",
  fontFamily: "system-ui",
};

function Content({
  tableData,
  loader,
  datehandler,
  resetdata,
  changeHandler,
  paginationHandler,
  // repurchase_status,
  exportData,
  printloader,
  changeOrdersTable,
  category,
  selectedCommissionType,
  selectedStartDate,
  selectedEndDate,
  // loader,
}) {
  console.log(tableData, "tableData in content goes here");
  const Currency = useSelector((state) => state.curr);
  const [date, SetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
  });
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  console.log("tableData", tableData);

  const ConvertData = (data) => {
    let newData = data.map((obj) => {
      if (obj.key) {
        return {
          ...obj,
          key: t("ewallet." + obj.key),
        };
      } else {
        return {
          ...obj,
        };
      }
    });
    return newData;
  };

  const columns = [
    {
      name: t("Common.transactionDate"),
      cell: (row) => {
        const adjustedTimestamp = moment
          .utc(row.transaction_date)
          .subtract(8, "hours");
        const formattedDate = adjustedTimestamp
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A");

        return <span>{formattedDate}</span>;
      },
      // selector: (row) =>
      //   moment(row.transaction_date).format("MM/DD/YYYY h:m:ss"),
    },
    {
      name: "Earned Date",
      // selector: (row) => moment(row.earned_date).format("MM/DD/YYYY h:m:ss"),
      selector: (row) => {
        if (row.earned_date === "") {
          return "-----------------------------";
        } else {
          const adjustedTimestamp = moment
            .utc(row.earned_date)
            .subtract(8, "hours");
          const formattedDate = adjustedTimestamp
            .tz("Asia/Manila")
            .format("MM/DD/YYYY h:mm:ss A");

          return <span>{formattedDate}</span>;
        }
      },
    },
    {
      name: t("Common.commission_type"),
      selector: (row) => t(`ewallet.${row.commission_type}`),
    },
    {
      name: "Details",
      selector: (row) =>
        row.username == ""
          ? t(`ewallet.${row.commission_type}`)
          : `${row.details} earned from ${row.username}`,
    },
    {
      name: t("Common.amount").toUpperCase(),
      cell: (row) => (
        <span className={`${style.credit} ${style.badge}`}>
          {Currency.currentCurr}{" "}
          {formatNumberWithCommasAndDecimal(
            row.amount * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },
    {
      name: t("Common.ilifestyle").toUpperCase(),
      cell: (row) => (
        <span className={`${row.classnameamount} ${style.badge}`}>
          {/* {Currency.currentCurr}{" "} */}
          {formatNumberWithCommasAndDecimal(
            row.ilifestyle * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },
    {
      name: t("Common.Status").toUpperCase(),
      // selector: (row) => row.status,
      cell: (row) => (
        <p
          style={
            row.status == "Suspended"
              ? { color: "red", fontWeight: "bold" }
              : { fontWeight: "bold" }
          }
        >
          {row.status}
        </p>
      ),
    },
    {
      name: "Suspended Amount",
      cell: (row) => (
        <span className={`${style.debit} ${style.badge}`}>
          {Currency.currentCurr}{" "}
          {formatNumberWithCommasAndDecimal(
            row.suspended_amount * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },
  ];

  const handlePageChange = (inPage) => {
    console.log(
      "per page changes",
      tableData,
      selectedStartDate,
      selectedEndDate
    );
    changeOrdersTable(inPage, tableData.perPage);
  };

  const handlePerRowsChange = (perPage, inPage) => {
    console.log(inPage, perPage, "per rows change");
    changeOrdersTable(inPage, perPage);
  };

  const filterHandlet = (start, end, type = "") => {
    console.log(" inside filter handler ", start, end, type);
    const selectedValues = type.map((item) => item.value);
    datehandler(start, end, selectedValues);
  };
  const resetData = () => {
    resetdata();
  };

  return (
    <div className={style.summary}>
      <div
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_tabContent}`
            : `${style.tabContent}`
        }`}
      >
        <div>
          <h5>Commission History</h5>
        </div>
        <div className={style.dataTable} style={stylees}>
          <Filter
            filterHandler={filterHandlet}
            type={ConvertData(category)}
            resetHandler={resetData}
            isSingle={false}
            exports={true}
            exportData={exportData}
            loader={loader}
            printloader={printloader}
            selectedCommissionType={selectedCommissionType}
            selectedStartDate={selectedStartDate}
            selectedEndDate={selectedEndDate}
          />
          <DataTable
            columns={columns}
            data={tableData.data}
            highlightOnHover
            progressPending={loader}
            progressComponent={<div>Loading</div>}
            persistTableHead
            noHeader
            pagination
            paginationServer
            responsive
            paginationTotalRows={tableData.totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            noDataComponent={t("Common.noDataRecordsToDisplay")}
            // //onSort={handleOnSort}
            exportData={exportData}
          />
        </div>
      </div>
    </div>
  );
}

export default Content;
